import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';

const ProfileUpload = ({ uploadProfileImage }) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => onDropHandler(files),
    multiple: false,
    maxSize: 1000000000,
  });

  const onDropHandler = (files) => {
    //setProfileImg(files[0]);
    uploadProfileImage(files[0]);
  };

  return (
    <>
      {/** DropZone */}
      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          border: 1,
          borderColor: 'grey.500',
        }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <PhotoCamera fontSize="large" />
      </Box>
    </>
  );
};
export default ProfileUpload;
